import FlexContainerBase from './_flex-container-base.js'
import FlexItemBase from './_flex-item-base.js'
import ConfigurablePane from './_configurable-pane.js'
import ConfigurableSizeBounds from './_configurable-size-bounds.js'
import ConfigurableTransition from './_configurable-transition.js'

export default {
  name: 'HideablePane',
  values: {
    style: {
      base: {
        zIndex: undefined,
        $mixin: [
          {
            configSet: FlexContainerBase,
          },
          {
            configSet: FlexItemBase,
          },
          {
            configSet: ConfigurablePane,
          },
          {
            configSet: ConfigurableSizeBounds,
          },
        ],
      },
      visible: {
        opacity: 1,
        transform: undefined,
        height: undefined,
        overflow: undefined,
      },
      toVisibleTransition: {
        configSet: ConfigurableTransition,
        configValues: {
          transitionDuration: '0.2s',
        },
      },
      hidden: {
        opacity: 0,
        transform: undefined,
        height: undefined,
        overflow: undefined,
      },
      toHiddenTransition: {
        configSet: ConfigurableTransition,
        configValues: {
          transitionDuration: '0.2s',
        },
      },
    },
    enableTransitions: true,
    renderHiddenContent: false,
    unmountOnExit: true,
    initialAnimation: false,
    createStackingContext: false,
    absolutePositionWhenHidden: false,
    warnAboutUnconditionallyRenderedContent: false,
  },
  meta: {
    extendable: false,
  },
}
